import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import React, { useEffect, useMemo, useState } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment';
import redirectURL from "../redirectURL";
import Select from 'react-select';
import { getHyphenDDMMYYYYHHMMSS,getDecoder } from '../common/utils';
import SweetAlert from "react-bootstrap-sweetalert";

function Transhipments() {
    const user = useMemo(() => getDecoder(), []);
    const [activeTab, setActiveTab] = useState('new_tranship')
    const [rowData ,setRowData] = useState([]);
    const [transhipHistoryRowData,setTransshipHistoryRowData] = useState([])
    const [startDate,setStartDate] = useState(new Date(moment.parseZone().subtract(10,'days')))
    const [endDate, setEndDate] =  useState(new Date())
    const [foNumber,setFONumber] = useState([])
    const [loadshow, setLoadShow] = useState("show-n")
    const [replacementDate,setReplaceDate] = useState('')
    const [sweetAlert,setSweetAlert] = useState({
      type:'',
      show:false,
      title:''
    })
    const [createdDate,setCreatedDate] = useState({label:'',value:''})
     const [formData,setFormData] = useState({
      truck_no:'',
      driver_mobile_no:'',
      driver_name:'',
      remarks :''
    })
    const [errorMessage,setErrorMessage] = useState('')
    const [foOptions,setFOOptions] = useState({label:'',value:''})
    const handleTab = (tabkey) =>{
        setActiveTab(tabkey)
    }
    const defaultColDef = useMemo(()=>{
      return{
        sortable:true,
        filter:true,
        pivot:true,
        resizeable :true,
        autoSizeColumns :true,
      }
    })
    useEffect(()=>{
      getFOData()
      getTransshipHistory()
    },[])
    const getFOData = async() =>{
      setLoadShow("show-m")
      try{
        let params ={status: [1, 2]}
       await redirectURL.post("/consignments/getFONumbers",params)
      .then(resp => {
        if(resp.data.status == 'success'){
          let fo_numbers = resp.data.data
          const foOptions = fo_numbers.map(fo=>({label:fo,value:fo}))
          setFOOptions(foOptions)
          setLoadShow('show-n')
        }
      })
    }
    catch(e){
      return e
    }
    }
    const getTransshipHistory = async() =>{
      setLoadShow("show-m")
      let params ={
        sdate:moment.parseZone(startDate).format("DD-MM-YYYY"),
        edate:moment.parseZone(endDate).format("DD-MM-YYYY")
      }
      try{
        await redirectURL.post("/consignments/transshipHistory",params)
      .then(resp =>{
        if(resp.data.status == 'success'){
          let transhipHistory = resp.data.data
          setTransshipHistoryRowData(transhipHistory)
          setLoadShow('show-n')
        }
      })
      }
      catch(e){
        return e
      }
    }
  const columnwithDefs = [{
    headerName: 'FO Number',
    field: 'fo_number'
  },
  {
    headerName: 'Vehicle No.',
    field: 'truck_no'
  },
  {
    headerName: 'Driver Mobile No.',
    field: 'driver_mobile_no'
  },
  {
    headerName:'Driver Name',
    field:'driver_name'
  },
  {
    headerName:'Created Date',
    field:'created_date',
    valueGetter:function(params){
      return getHyphenDDMMYYYYHHMMSS(params.data.created_date)
    }
  },
  {
    headerName: "Plant Name",
    field: "consigner_name",
    width: 130,
    valueGetter: function (params) {
      if (params.data.consigner_name != undefined && params.data.consigner_name != '') {
        return params.data.consigner_name
      }
    }
  },
  {
    headerName: "Customer Name",
    field: "consignee_name"
  },
  {
    headerName: "Tracking Mode",
    field: "tracking_mode"
  },
  {
    headerName: 'Movement Type',
    field: 'movement_type',
  },
  {
    headerName:'Transporter Name',
    field:'transporter_name'
  }
  ]
  const transhipHistoryColDefs = [{
 headerName: 'FO Number',
    field: 'fo_number'
  },
  {
    headerName: 'Original Truck No.',
    field: 'old_truck_no'
  },
  {
    headerName: 'Replacement Truck No.',
    field: 'truck_no'
  },
  {
    headerName: 'Driver Mobile No.',
    field: 'driver_mobile_no'
  },
  {
    headerName:'Driver Name',
    field:'driver_name'
  },
  {
    headerName:'Created Date',
    field:'created_date',
    valueGetter:function(params){
      return getHyphenDDMMYYYYHHMMSS(params.data.created_date)
    }
  },
  {
    headerName: "Plant Name",
    field: "consigner_name",
    width: 130,
    valueGetter: function (params) {
      if (params.data.consigner_name != undefined && params.data.consigner_name != '') {
        return params.data.consigner_name
      }
    }
  },
  {
    headerName: "Customer Name",
    field: "consignee_name"
  },
  {
    headerName: "Tracking Mode",
    field: "tracking_mode"
  },
  {
    headerName: 'Movement Type',
    field: 'movement_type',
  },
  {
    headerName:'Transporter Name',
    field:'transporter_name'
    },
    {
      headerName:'Transhipment Date',
      field:'transshipment_date',
      valueGetter:function (params){
        return getHyphenDDMMYYYYHHMMSS(params.data.transshipment_date)
      }
    },
    {
      headerName:'Remarks',
      field:'transhipment_reason'
    }
  ]
  const handleDateChange =(date,name) =>{
    setReplaceDate(date)
    if(name == 'replace_date'){
      if(!!!foNumber?.value){
        setSweetAlert({
          type:'danger',
          show:true,
          title:'Please Select FO Number'
        })
      }
    }
    else{
    name == 'startDate' ? setStartDate(date) : setEndDate(date)
    }
  }
  const handleFoTranship =(selectedFO) =>{
    if(selectedFO){
      setFONumber(selectedFO)
    }
    else{
      setRowData([]);
     setFONumber([]);
    }
  }
  const handleSubmit = async() =>{
    setLoadShow("show-m")
    try{
      if(activeTab == 'new_tranship'){
   let params = {
        searchtype: "fo_number",
        searchnumber: [foNumber.value],
      }
    await redirectURL.post("/consignments/gateActiveFOSearchFilter",params)
    .then(resp =>{
       if(resp.data.status == 'success'){
            let data = JSON.parse(resp.data.apiData)
            let all_data = parseJSONSafely(data, "all_data")
          setRowData(all_data)
          setLoadShow("show-n")
            const uniqueFoCreatedDate = Array.from(
            new Map(
              all_data.map(item => [item.fo_number, { fo_number: item.fo_number, created_date: item.created_date }])
            ).values()
          ); 
          const foOptions = uniqueFoCreatedDate.map(item => ({
            label: item.fo_number,      // only show FO number
            value: item.created_date                  // store both fo_number & created_date
          }));
          setCreatedDate(foOptions)
       }
    })
  }
  else{
    getTransshipHistory()
  }
  }
  catch(e){
    return e
  }
  }
  const handleNewData = (e,name) =>{
    let assignedValue = e.target.value.trim()
    if(name == 'truckNo'&& (assignedValue === '' || /^[a-zA-Z]/.test(assignedValue))){
      setFormData(prev =>({
        ...prev,
        truck_no:assignedValue.toUpperCase()
      }))
    }
    else if(name == "driverNo" && (assignedValue === '' || /^[6-9][0-9]*$/.test(assignedValue))){
      setFormData(prev =>({
        ...prev,
        driver_mobile_no:assignedValue
      }))
    }
    else if(name == "driverName"){
       const formattedValue = assignedValue.charAt(0).toUpperCase() + assignedValue.slice(1);
      setFormData(prev =>({
        ...prev,
        driver_name:formattedValue
      }))
    }
    else if(name == 'remarks'){
      setFormData(prev =>({
        ...prev,
        remarks:e.target.value
      }))
    }
  }
  const handleDriverNo = (e) =>{
    if(formData?.driver_mobile_no.length > 0 && formData?.driver_mobile_no.length < 10){
      setErrorMessage("Invalid Mobile No.")
    }
    else{
      setErrorMessage('')
    }
  }
  const handleReplacement = async(e) =>{
    e.preventDefault()
    if(foNumber.value == ''){
      setSweetAlert({
        show:true,
        type:'danger',
        title:'Please Select FO Number'
      })
      return
    }
    if(formData?.truck_no == '' && formData?.driver_mobile_no == ''){
      setSweetAlert({
        type:'danger',
        show:true,
        title:'Please Enter Truck Number (or) Driver No.'
      })
      return
    }
    if(formData?.driver_mobile_no != '' && formData?.driver_name == ''){
      setSweetAlert({
        show:true,
        type:'danger',
        title:'Please Enter Driver Name'
      })
      return
    }
     let created_date = createdDate.filter(item => foNumber.value == item.label).map(item => item.value)
    let fo_date = moment.utc(created_date?.[0])
      const updatedDate = moment(replacementDate).utc("+05:30").utcOffset(0)
      if(fo_date.isAfter(updatedDate)){
        setSweetAlert({
          type:'danger',
          show:true,
          title:'Date & time must be after created date.'
        })
        return
      }
    let params ={
      fo_number: foNumber?.value,
      truck_no : formData?.truck_no,
      driver_mobile_no:formData?.driver_mobile_no,
      driver_name:formData?.driver_name,
      remarks:formData?.remarks,
      tranship_time: moment.parseZone(replacementDate).format("DD-MM-YYYY HH:mm:ss"),
      user_email:user?.email
    }
    setLoadShow('show-m')
    await redirectURL.post("/consignments/transhipData",params)
    .then(res =>{
      if(res.data.status == 'success'){
        setSweetAlert({
          show:true,
          type:'success',
          title:"Transhipment Successfully"
        })
        setFONumber([])
        setRowData([])
        setFormData({
          driver_mobile_no:'',
          driver_name:'',
          truck_no:'',
          remarks:''
        })
        setReplaceDate('')
        setLoadShow('show-n')
      }
      else{
        setSweetAlert({
          show:true,
          type:'danger',
          title:"Transshipment failed"
        })
        setLoadShow('show-n')
      }
    })
    
  }
  const loadData = async(a) =>{
    setSweetAlert({
      show: false,
      type: '',
      title: ''
    })
  }
  
  return (
    <>
    <div>
    <div>
      <SweetAlert
      type ={sweetAlert?.type}
      show={sweetAlert?.show}
      title={sweetAlert?.title}
      onConfirm={loadData}
       />
    </div>
        <h5>Transshipments</h5>
        <div className='mt-2'>
        <div className='d-flex tranship_tabs'>
            <div className={ activeTab == 'new_tranship' ? "btn btn-info f14" :"btn tab-btn f14"} onClick={() =>handleTab("new_tranship")}>New Transshipments</div>
            <div className={activeTab == 'tranship_history' ? "btn btn-info f14":'btn tab-btn f14'} onClick={() =>handleTab("tranship_history")}>Transshipment History</div>
        </div>  
        </div>
        <div className='row'>
          <div className='col-xl-12 col-lg-12'>
            <div className='card'>
              <div className='card-body'>
                {activeTab == 'new_tranship' && 
                <div>
                <div className='mb-3 fo_div'>
                  <div>
              <label className='col-12 f14'>Enter FO Number for Transhipment<span className='mandatory_field'>*</span></label><br />
              <Select className='col-12 mb-2 mr-3 tranship_input'
              placeholder="Select FO Number"
              value={foNumber}
              options={foOptions}
              onChange={handleFoTranship}
              required
              isClearable
              />
              </div>
                <button className='btn btn-success submit_fo' onClick={handleSubmit}>Submit</button>
              {/* </div> */}
              </div>
              <div className='ag-theme-balham mt-8 mb-10' style={{height:"500px", width:'100%',paddingLeft:'15px' , marginBottom:'15px'}}>
              <AgGridReact 
              columnDefs={columnwithDefs}
              defaultColDef={defaultColDef}
              rowData={rowData}
              pagination={true}
              paginationPageSize={50}
              />
              </div>
              <form onSubmit={handleReplacement}>
              <div className='row col-xl-12 col-lg-12 d-flex button-group'>
                <div className='col-xl-2 col-lg-2 form-group'>
                <label className='mt-10' >Replacement Truck No</label>
                <input 
                className='col-12 button_label'
                type='text'
                value={formData?.truck_no}
                name="truckNo"
                onChange={(e) =>handleNewData(e,"truckNo")}
                /></div>
                <div className='col-xl-2 col-lg-2 form-group'>
                        <label>Replacement Driver No</label>
                        <input
                          className='col-12 button_label'
                          type='text'
                          value={formData?.driver_mobile_no}
                          name="driverNo"
                          onChange={(e)=>handleNewData(e,"driverNo")}
                          onBlur={handleDriverNo}
                          maxLength={10}
                          autocomplete="off" 
                        />
                    {errorMessage && <p className='mandatory_field'>{errorMessage}</p>}
                    </div>
                <div className='col-xl-2 col-lg-2 form-group'>
                        <label>Replacement Driver Name</label>
                        <input
                          className='col-12 button_label'
                          type='text'
                          value={formData?.driver_name}
                          name="driverName"
                          onChange={(e)=>handleNewData(e,"driverName")}
                          autocomplete="off" 
                        />              
                    </div>
                <div className='col-xl-2 col-lg-2 form-group'>
                        <label>Replacement Datetime <span className='mandatory_field'>*</span></label>
                        <DatePicker
                          selected={replacementDate}
                          name="replace_date"
                          autoComplete="off"
                          showTimeInput
                          onChange={(date)=>handleDateChange(date,"replace_date")}
                          dateFormat="dd/MM/yyyy h:mm a"
                          className="col-12 datepicker-custom"
                          popperPlacement="bottom"
                          maxDate={new Date()}
                          required
                        />    
                    </div>
                    
                <div className='col-xl-2 col-lg-2 form-group'>
                <label className='mt-10'>Remarks <span className='mandatory_field'>*</span></label><br/>
                <input
                type='text'
                className='col-12 button_label'
                value={formData?.remarks}
                onChange={(e)=>handleNewData(e,"remarks")}
                required
                 />
              </div>
              <div className='col-1 mt-4'>
                
                <button className='btn btn-success submit_button'>Submit</button>
              </div>
              </div></form>
              </div>}
              {activeTab == 'tranship_history' && <div>
                <div className='form-container d-flex'>
                <div className='col-3'>
                  <label>From Date<span className='mandatory_field'>*</span></label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) =>handleDateChange(date,"startDate")}
                      name="startDate"
                      autoComplete="off"
                      dateFormat="dd/MM/yyyy"
                      className="datepicker-custom"
                      maxDate={new Date()}
                    />                  
                    </div>
                    <div className='col-3'>
                  <label>To Date <span className='mandatory_field'>*</span></label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) =>handleDateChange(date,"endDate")}
                      name="endDate"
                      autoComplete="off"
                      dateFormat="dd/MM/yyyy"
                      className="datepicker-custom"
                      maxDate={new Date()}
                    />  
                  </div>
                    <div className="button-wrapper mt-3">
                    <button className='btn btn-success mt-3 submit_button' onClick={handleSubmit}>Submit</button>
                    </div>
                  </div>
                  <div className='ag-theme-balham mt-8 mb-10' style={{height:"500px", width:'100%',paddingLeft:'15px' , marginBottom:'15px',marginTop:'10px'}}>
              <AgGridReact 
              columnDefs={transhipHistoryColDefs}
              defaultColDef={defaultColDef}
              rowData={transhipHistoryRowData}
              pagination={true}
              paginationPageSize={50}
              />
              </div>
                  </div>}
              <div>

              </div>
              </div>
            </div>
          </div>
        </div>
          <div className={"dataLoadpage " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
    </div>
    </>
  )
}

export default Transhipments

function parseJSONSafely(data, key) {
    try {
        if (data[key] == undefined)
            return []
        return JSON.parse(data[key]);
    } catch (error) {
        console.error(`Error parsing JSON for key "${key}":`, error);
        return []; // Return a default value, e.g., null or an empty object
    }
}
